
import { defineComponent, PropType, reactive, ref, Ref, computed } from "vue";
interface Prop {
   label?: string;
   id?: string | number | null;
   children?: string;
   disabled?: boolean;
   isLeaf?: boolean;
}
export default defineComponent({
   emits: ["handleNode"],
   props: {
      /**
       * @param {Array} data 树数据列表
       */
      data: {
         type: Array as PropType<any[]>,
         default: (): any[] => [],
      },

      /**
       * 同element tree 一样
       */
      props: {
         type: Object as PropType<Prop>,
         default: (): Prop => {
            return {};
         },
      },
   },
   setup(props, ctx) {
      const tree: Ref<null> = ref(null);
      const setProps = computed(
         (): Prop => {
            let defaultProps: Prop = {
               label: "label",
               id: "id",
               children: "children",
            };
            return Object.assign({}, defaultProps, props.props);
         }
      );

      const nodeClick = (data: any): void => {
         ctx.emit("handleNode", data);
      };

      const setCurrentNode = (node: any): void => {
         (tree.value as any).setCurrentNode(node);
      };

      const getCurrentNode = (node: any): any => {
         return (tree.value as any).getCurrentNode();
      };

      return {
         tree,
         setProps,
         nodeClick,
         setCurrentNode,
         getCurrentNode,
      };
   },
});
